import React, { useEffect, useState, useContext } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
// import CsvDownloader from 'react-csv-downloader';
import { Layout, Row, Col, Select, Input, DatePicker, message } from 'antd';
import { get } from 'lodash';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
import queryString from 'query-string';

import PdButton from 'components/pd-button';
import StatusList from 'components/list-status';
import { TableList } from 'components/table-list';

import { ProfileContext } from 'contexts/profile';

import OrderService from 'services/order';
import RentService from 'services/rent';
import { priceFormat } from 'utils';
import addDay from 'utils/addDay';

const { Content } = Layout;
const { Search } = Input;
const { Option } = Select;
const { RangePicker } = DatePicker;

const dateFormat = 'YYYY/MM/DD';

export function RentOrders() {
  const location = useLocation();
  const [couriers, setCouriers] = useState([]);
  const [endDatePick, setEndDate] = useState('');
  const [loadStatus, setLoadStatus] = useState(true);
  const [nextPage, setNextPage] = useState(1);
  const [orderForDownload, setOrderForDownload] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [page, setPage] = useState(1);
  const [searchValue, setSearchValue] = useState('');
  const [selectedCourier, setSelectedCourier] = useState('');
  const [sortBy, setSortBy] = useState('ordered_at desc');
  const [startDatePick, setStartDate] = useState('');
  const [status, setStatus] = useState('');

  const navigate = useNavigate();
  const parsed = queryString.parse(location.search);

  const { fetchProfile } = useContext(ProfileContext);

  const customElement = (row) => (
    <div className="button-table">
      <Link to={`/orders/detail?id=${get(row, 'id', '')}`}>
        <PdButton type="primary" style={{ height: 32, width: 100 }}>
          See Detail
        </PdButton>
      </Link>
    </div>
  );

  customElement.displayName = 'customButton';

  const [columns] = useState([
    {
      name: 'Order No.',
      selector: row => row.formatted_id,
      width: '10%',
    },
    {
      name: 'Date',
      selector: row => row.ordered_at,
      format: (row) => {
        return dayjs(row.ordered_at).format('DD/MM/YYYY');
      },
      width: '13%',
      center: true,
    },
    {
      name: 'Customer',
      selector: row => row.user.full_name,
      width: '15%',
    },
    {
      name: 'Courier',
      selector: row => row.courier.title,
      width: '15%',
    },

    {
      name: 'Amount',
      selector: row => row.net_price,
      width: '15%',
      format: (row) => {
        return 'IDR ' + priceFormat(row.net_price);
      },
    },
    {
      name: 'Status',
      selector: row => row.status,
      format: (row) => {
        if (row.status === 'due_soon') {
          return 'Nearly Expired';
        }
        let str = row.status.split('_');
        str = str.map((item) => {
          return item.charAt(0).toUpperCase() + item.slice(1);
        });
        return str.join(' ');
      },
      width: '15%',
      center: true,
    },
    {
      name: '',
      cell: customElement,
      center: true,
      width: '20%',
    },
  ]);

  async function fetchOrderForDownload(
    filter,
    query,
    sort,
    courier,
    startDate,
    endDate
  ) {
    let newEndDate = endDate;
    if (newEndDate) {
      newEndDate = addDay(endDate, 1);
    }
    setOrderForDownload([]);
    const { data } = await OrderService.getOrderReport(
      filter,
      query,
      startDate,
      newEndDate,
      sort,
      courier,
      1
    );
    const orderData = data.data;
    setOrderForDownload(orderData);
  }

  async function fetchOrderList({
    courier,
    endDate,
    filter,
    limit = 10,
    page = 1,
    q,
    sort,
    startDate,
    status,
  }) {
    setLoadStatus(true);
    try {
      let newEndDate = endDate;
      if (newEndDate) {
        newEndDate = addDay(endDate, 1);
      }

      const {
        data: { data: orderData, metadata },
      } = await RentService.getOrderList({
        courier,
        endDate: newEndDate,
        filter,
        limit,
        page,
        q,
        sort,
        startDate,
        status,
      });
      setNextPage(get(metadata, 'next_cursor', 1));
      setLoadStatus(false);
      setOrderList(orderData);
    } catch {
      setOrderList([]);
      setNextPage(1);
    } finally {
      setLoadStatus(false);
    }
  }

  async function getCourierList() {
    try {
      const { data } = await OrderService.getCourierList();
      const CourierList = data.data;
      setCouriers(CourierList);
    } catch (err) {
      const errMessage = get(
        get(get(err, 'response', {}), 'data', {}),
        'message',
        ''
      );
      if (errMessage) {
        message.error(errMessage);
      } else {
        message.error('Cannot connect to server, please check connection');
      }
    }
  }

  function changePage(page) {
    if (page < 1) page = 1;
    parsed['page'] = page;
    const stringified = queryString.stringify(parsed);
    navigate({
      pathname: '/rent_orders',
      search: stringified,
    });
  }

  // async function downloadCsv() {
  //   await OrderService.downloadCsv();
  // }

  function onChangeDate(dates, datesString) {
    const startDate = datesString[0];
    if (startDate === '') {
      delete parsed['startDate'];
    } else {
      parsed['startDate'] = startDate;
    }

    const endDate = datesString[1];
    if (endDate === '') {
      delete parsed['endDate'];
    } else {
      parsed['endDate'] = endDate;
    }

    parsed['page'] = 1;

    const stringified = queryString.stringify(parsed);
    navigate({
      pathname: '/rent_orders',
      search: stringified,
    });
  }
  function filterOrder(param, val) {
    if (val === '' || val === 0) {
      delete parsed[param];
    } else {
      parsed[param] = val;
    }
    parsed['page'] = 1;
    const stringified = queryString.stringify(parsed);
    navigate({
      pathname: '/rent_orders',
      search: stringified,
    });
  }

  function resetFilter() {
    delete parsed['page'];
    delete parsed['q'];
    delete parsed['status'];
    delete parsed['sortBy'];
    delete parsed['courier'];
    delete parsed['startDate'];
    delete parsed['endDate'];
    delete parsed['limit'];

    const stringified = queryString.stringify(parsed);
    navigate({
      pathname: '/rent_orders',
      search: stringified,
    });
  }

  useEffect(() => {
    getCourierList();
    fetchProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* eslint-disable */
  useEffect(() => {
    if (parsed['q']) {
      setSearchValue(parsed['q']);
    } else {
      setSearchValue('');
    }

    if (parsed['page']) {
      if (parsed['page'] < 1) {
        parsed['page'] = 1;
        const stringified = queryString.stringify(parsed);
        navigate({
          pathname: '/rent_orders',
          search: stringified,
        });
      } else {
        setPage(parsed['page']);
      }
    } else {
      setPage('1');
    }

    if (parsed['status']) {
      setStatus(parsed['status']);
    } else {
      setStatus('');
    }

    if (parsed['sortBy']) {
      setSortBy(parsed['sortBy']);
    } else {
      setSortBy('ordered_at desc');
    }

    if (parsed['courier']) {
      setSelectedCourier(parsed['courier']);
    } else {
      setSelectedCourier(0);
    }

    if (parsed['startDate']) {
      setStartDate(parsed['startDate']);
    } else {
      setStartDate('');
    }

    if (parsed['endDate']) {
      setEndDate(parsed['endDate']);
    } else {
      setEndDate('');
    }

    fetchOrderList({
      courier: parsed['courier'],
      endDate: parsed['endDate'],
      page: parsed['page'],
      q: parsed['q'],
      sort: parsed['sortBy'],
      startDate: parsed['startDate'],
      status: parsed['status'],
      total: 10,
    });
    fetchOrderForDownload(
      parsed['status'],
      parsed['q'],
      parsed['sortBy'],
      parsed['courier'],
      parsed['startDate'],
      parsed['endDate']
    );
  }, [
    parsed['page'],
    parsed['q'],
    parsed['status'],
    parsed['sortBy'],
    parsed['courier'],
    parsed['startDate'],
    parsed['endDate'],
  ]);
  /* eslint-enable */

  return (
    <Layout className="pd-cms-orders main-container">
      <div className="content">
        <div className="pageTitle">Rent</div>
        <Content className="pageContent">
          <Row gutter={18}>
            <Col span={14}>
              <Search
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                enterButton
                className="search-product"
                placeholder="Search Rent Order List"
                onSearch={(val) => filterOrder('q', val)}
              />
            </Col>
            {orderForDownload.length > 0 ? (
              // Hidden Download Button

              // <Col span={4} offset={5}>
              //   <CsvDownloader
              //     datas={orderForDownload}
              //     filename="order-data-homestory"
              //     wrapColumnChar=""
              //     separator=",">
              //     <PdButton
              //       type="primary"
              //       onClick={downloadCsv}
              //       style={{ height: 32, width: 150 }}
              //       outline>
              //       Download as CSV
              //     </PdButton>
              //   </CsvDownloader>
              // </Col>

              // Remove this to unhide Download Button
              <Col span={4} offset={5} className="height-32">
                <div className="invisible">invisible</div>
              </Col>
            ) : (
              <Col span={4} offset={5} className="height-32">
                <div className="invisible">invisible</div>
              </Col>
            )}
            <Col span={7} className="mt-1">
              <RangePicker
                className="w-full"
                format={dateFormat}
                onChange={onChangeDate}
                value={[
                  startDatePick && dayjs(startDatePick, dateFormat),
                  endDatePick && dayjs(endDatePick, dateFormat),
                ]}
              />
            </Col>
            <Col span={4} className="mt-1">
              <Select
                style={{ width: '100%' }}
                value={Number(selectedCourier)}
                onChange={(val) => filterOrder('courier', val)}>
                <Option value={0}>All Couriers</Option>
                {couriers.map((courier, i) => (
                  <Option key={i} value={courier.id}>
                    {courier.title}
                  </Option>
                ))}
              </Select>
            </Col>
            <Col span={3} className="mt-1">
              <Select
                value={sortBy}
                style={{ width: '100%' }}
                onChange={(val) => filterOrder('sortBy', val)}>
                <Option value="ordered_at desc">Latest</Option>
                <Option value="ordered_at asc">Oldest</Option>
                <Option value="status">Status</Option>
              </Select>
            </Col>
            <Col span={4} className="mt-1">
              <span className="reset-filter" onClick={resetFilter}>
                Reset Filter
              </span>
            </Col>

            <Col span={24}>
              <Row gutter={10}>
                <Col span={3} className="mt-2">
                  <span style={{ marginRight: '10px' }}>Filter by Status:</span>
                </Col>
                <Col span={19} className="mt-1">
                  <Row>
                    <StatusList
                      onChange={(val) => filterOrder('status', val)}
                      selectedStatus={status}
                      statusList={[
                        '',
                        'waiting_payment',
                        'payment_verified',
                        'processed',
                        'shipped',
                        'rented',
                        'nearly_expired',
                        'charged',
                        'late',
                        'rent_returned',
                        'cancelled',
                        'rejected',
                        'exchange_request',
                        'exchange_accepted',
                        'exchange_rejected',
                        'exchange_on_delivery',
                        'refund_processed',
                      ]}
                    />
                  </Row>
                </Col>
              </Row>
            </Col>

            {!loadStatus && (
              <TableList
                changePage={changePage}
                columns={columns}
                loadingOrder={loadStatus}
                nextPage={nextPage}
                orderList={orderList}
                page={page}
                responsive={false}
              />
            )}
          </Row>
        </Content>
      </div>
    </Layout>
  );
}

export default { RentOrders };
